import { useState, useEffect } from "react";
import Loader from "react-loader-spinner";
import { checkoutForLink } from "../../Redux/Actions/jobs";
import * as localizationActions from "../../Redux/Actions/localization";
import { toastMessage } from "../../utils/toast";
import { getLocaleValue } from "../../utils";

const PaymentCheckout = () => {
  const [currentItems, setCurrentItems] = useState([]);
  const [totalAmount, setTotalAmount] = useState(0);
  const [currency, setCurrency] = useState("");
  const [buttonLoading, setButtonLoading] = useState(false);
  const [loading, setLoading] = useState(false);
  const [payURL, setPayURL] = useState("");

  const [responseStatus, setResponseStatus] = useState(false);
  const [responseMessage, setResponseMessage] = useState("");

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    await getLocalization();
    const url = new URL(window.location.href);
    const idParam = url.searchParams.get('id');
    await checkoutForLinkApi(idParam);
  };

  const getLocalization = async () => {
    try {
      const [resEN, resAR] = await Promise.all([
        localizationActions.localization("EN"),
        localizationActions.localization("AR")
      ]);
  
      if (resEN) {
        localStorage.setItem("localEn", JSON.stringify(resEN));
      } else {
        localStorage.setItem("localEn", "");
        toastMessage("error", (resEN && resEN.message) || `Unable to load the eng Localization`);
      }
  
      if (resAR) {
        localStorage.setItem("localAr", JSON.stringify(resAR));
      } else {
        localStorage.setItem("localAr", "");
        toastMessage("error", (resAR && resAR.message) || `Unable to load the ar Localization`);
      }
    } catch (err) {
      toastMessage("error", (err && err.response && err.response.message) || `Unable to load localization`);
    }
  };
  
  const checkoutForLinkApi = async (id) => {
    setLoading(true);
    try {
      const response = await checkoutForLink(id);
      if (response?.data) {
        setResponseStatus(true)
        setPayURL(response.data?.data?.paymentLink);
        setTotalAmount(response.data?.data?.totalAmount);
        setCurrency(response.data?.data?.currency);
        let summary = response.data?.data?.summary;
        let summaryData = summary.map(({ amount, description }) => {
          return {
            amount: amount,
            summary: getLocaleValue(description),
          };
        });
        setCurrentItems(summaryData);
      }
    } catch (error) {
      setResponseMessage(error?.response?.data?.Message || error?.response?.data?.message)
      setButtonLoading(false);
      setLoading(false);
    }
    setLoading(false);
  }

  const openPaymentPage = () => {
    setButtonLoading(true);
    window.open(payURL, "_blank");
  };

  return (
    <div>
      {loading ? (
        <div className="d-flex align-items-center justify-content-center h-75vh">
          <Loader
            type="ThreeDots"
            color="#2d207d"
            height={40}
            width={40}
            style={{ textAlign: "center" }}
          />
        </div>
      ) : (
        <div>
          <div style={{ textAlign: "center" }}>
            <div>
              <div
                className="logo logo-admin"
                style={{ left: "60px", top: 0 }}
              >
                <img
                  src="/Assets/aamer_logo.jpg"
                  width="150px"
                  height="auto"
                  alt="logo"
                  className="auth-logo"
                />
              </div>
              <span
                style={{
                  fontSize: "30px",
                  fontWeight: "500",
                  borderBottom: "5px solid #b71c1c",
                  paddingTop: "1%",
                  display: "inline-block",
                  marginBottom: "2%",
                }}
              >
                {getLocaleValue("checkout_title")}
              </span>
            </div>
          </div>
          <div className="d-flex justify-content-center">
            <div className="col-md-5">
              <div className="card">
                <div className="d-flex mt-2">
                  <div
                    className="col-lg-12 col-sm-12 col-md-12 card"
                    style={{ border: "0px solid" }}
                  >
                    {responseStatus ? (
                      <div className="card-body form-group fv-plugins-icon-container mb-0">
                        <div style={{ textAlign: "center" }}>
                          <div>
                            <span
                              className="card-title font-weight-bolder text-dark"
                              style={{ fontSize: "20px" }}
                            >
                              {getLocaleValue("checkout_order_summary")}
                            </span>
                          </div>
                        </div>
                        <div className="mt-1 d-flex flex-wrap">
                          <table
                            className="table mb-0"
                          >
                            <tbody>
                              {currentItems.map(({ sno, summary, amount }) => {
                                return (
                                  <tr key={sno}>
                                    <td>
                                      <span
                                        className="fw-bold"
                                      >
                                        {summary}
                                      </span>
                                    </td>
                                    <td></td>

                                    <td>
                                      <span
                                        className="fw-bold"
                                      >
                                        {amount} {currency}
                                      </span>
                                    </td>
                                  </tr>
                                );
                              })}
                              <tr>
                                <td>
                                  <span
                                    className="fw-bold"
                                  >
                                    {getLocaleValue("checkout_total")}
                                  </span>
                                </td>
                                <td></td>
                                <td>
                                  <span
                                    className="fw-bold"
                                  >
                                    {`${totalAmount} ${currency}`}{" "}
                                  </span>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                        {
                          <div
                            className="d-flex justify-content-center"
                          >
                            <button
                              className="btn btn-primary d-flex align-items-center"
                              disabled={buttonLoading}
                              onClick={openPaymentPage}
                            >
                              <span
                                style={{
                                  fontWeight: 500,
                                  fontSize: "15px",
                                  padding: "5px",
                                }}
                              >
                                {buttonLoading
                                  ? getLocaleValue("payment_processing")
                                  : getLocaleValue("checkout_btn")}
                              </span>
                              {buttonLoading && (
                                <Loader
                                  type="Oval"
                                  color="#fff"
                                  height={20}
                                  width={20}
                                  style={{ marginLeft: "10px" }}
                                />
                              )}
                            </button>
                          </div>
                        }
                      </div>
                    ) : (
                      <div>
                        <div class="text-sm text-md text-lg text-center p-2 fw-bold">
                          {responseMessage}
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default PaymentCheckout;
